import React, { HTMLProps } from 'react';
import { useTranslation } from 'next-i18next';
import Icon from '@components/atoms/icon/icon';
import clsx from 'clsx';
import styles from './seller-on-vacation.module.scss';

export type SellerOnVacationProps = Pick<HTMLProps<HTMLDivElement>, 'className'>;

const SellerOnVacation: React.FC<SellerOnVacationProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div
      className={clsx(styles.sellerVacation, 'vc-text-m', className)}
      data-cy="holiday_mode_text"
    >
      <Icon
        name="holiday-mode-default"
        className={styles.sellerVacation__icon}
      />
      <p>
        <span className={styles.sellerVacation__title}>
          {t('PRODUCT.DETAILS.SELLER_VACATION.NOTIFICATION', 'The seller is on vacation.')}
        </span>{' '}
        <span>{t('PRODUCT.DETAILS.SELLER_VACATION.MESSAGE', 'Favorite this item to check back later.')}</span>
      </p>
    </div>
  );
};

export default SellerOnVacation;
